import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { INVENTORY_PERMISSIONS } from '../constants/permissions.constants';

/**
 * Permisos de Gestión en Almacén (bloqueo / liberar bloqueo).
 */
export const useInventoryWarehousePermissions = () => {
  const canView = usePermission(INVENTORY_PERMISSIONS.WAREHOUSE.VIEW);
  const canEdit = usePermission(INVENTORY_PERMISSIONS.WAREHOUSE.EDIT);
  const canTransfer = usePermission(INVENTORY_PERMISSIONS.WAREHOUSE.TRANSFER);
  const canReserve = usePermission(INVENTORY_PERMISSIONS.WAREHOUSE.RESERVE);
  const canUnreserve = usePermission(INVENTORY_PERMISSIONS.WAREHOUSE.UNRESERVE);

  return useMemo(
    () => ({
      canView,
      canEdit,
      canTransfer,
      canReserve,
      canUnreserve,
    }),
    [canView, canEdit, canTransfer, canReserve, canUnreserve],
  );
};
